const k = 0.8;

export const chartHeight = {
  xs: 100 * k,
  s: 220 * k,
  m: 400 * k,
  l: 560 * k,
};
